import { GET_PORTAL_NOTICE } from '../../constants';

export function getPortalNotice() {
  return {
    type: GET_PORTAL_NOTICE,
    request: {
      op: 'get',
      path: `/@portal-notice`,
    },
  };
}
